import React from 'react';

import CommenterList from 'buyside/components/presentation/Feed/CommenterList/commenterList';
import FundProfile from 'buyside/components/presentation/Feed/FundProfile/fundProfile';
import Idea from 'buyside/components/presentation/Feed/Idea/idea';
import IdeaUpdate from 'buyside/components/presentation/Feed/IdeaUpdate/ideaUpdate';
import Post from 'buyside/components/presentation/Feed/Post/post';
import WhitePaperFeedItem from 'buyside/components/presentation/Feed/WhitePaper/WhitePaperFeedItem';

import { FeedItemComponentType } from 'interfaces/feed/feedItems';
import { ActivityFeedPublishedCommentFragment } from 'interfaces/graphql-typings';

import styles from './publishedCommentStyles.scss';

// Once comments are added to other features you can add more renders statement here to handle (can use comment.commentObject.__typename)
const PublishedComment: React.FC<{
  comment: ActivityFeedPublishedCommentFragment;
} & FeedItemComponentType> = ({
  comment,
  handleClick,
  currentUser,
  eventVerb,
  feedItemId,
  isPublic
}) => {
  let CardComponent;

  switch (comment?.commentObject?.__typename) {
    case 'Idea':
      CardComponent = (
        <Idea
          currentUser={currentUser}
          eventVerb={eventVerb}
          idea={comment?.commentObject}
          isPublic={isPublic}
          feedItemId={feedItemId}
        />
      );
      break;
    case 'IdeaUpdate':
      CardComponent = (
        <IdeaUpdate
          createdAt={comment?.commentObject?.createdAt}
          currentUser={currentUser}
          eventVerb={eventVerb}
          handleClick={handleClick}
          ideaUpdate={comment.commentObject}
          feedItemId={feedItemId}
        />
      );
      break;
    case 'EmployerProfile':
      CardComponent = <FundProfile fundProfile={comment?.commentObject} />;
      break;
    case 'Post':
      if (comment.commentObject) {
        CardComponent = (
          <Post currentUser={currentUser} post={comment.commentObject} feedItemId={feedItemId} />
        );
      }
      break;
    case 'WhitePaper':
      CardComponent = (
        <WhitePaperFeedItem
          currentUser={currentUser}
          whitePaper={comment?.commentObject}
          feedItemId={feedItemId}
        />
      );
      break;
    default:
      CardComponent = <p>Unimplemented</p>;
  }

  return (
    <div>
      <div className={styles.feedItemHeader}>
        {feedItemId && (
          <CommenterList
            feedItemId={feedItemId}
            showCommenterName={Boolean(currentUser?.canViewUserDetails)}
          />
        )}
      </div>
      {CardComponent}
    </div>
  );
};

export default PublishedComment;
